import Translate from '@apps/maha/admin/components/translate'
import MJSONDesigner from '@admin/components/mjson_designer'
import { canAccess } from '@core/utils/access'
import Panel from '@admin/components/panel'
import React from 'react'

const getDesigner = (props, context) => ({
  editable: canAccess({ rights: { $allOf: ['forms:manage_forms'] } },context.admin),
  endpoint: `/forms_embeds/${props.embed.id}`,
  preview: `/mjson/dynamic/forms_embeds/${props.embed.code}`,
  root_route: `/forms/forms/${props.form.id}/embeds/${props.embed.id}/design`,
  type: 'page',
  versionable: true
})

const mapPropsToPanel = (props, context) => ({
  title: `${props.embed.title} - Design`,
  component: <MJSONDesigner { ...getDesigner(props, context) } />,
  tasks: {
    items: [
      {
        label: 't(Translate Campaign)',
        svg: 'flag',
        modal: <Translate entity_type='forms_embeds' entity_id={ props.embed.id } mjson_type='page' publish={ false } />
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
